
import React, { useEffect, useRef, useState } from 'react';
import { star } from '../../../../../src/assets';
import { height } from '@mui/system';

interface BannerCardViewProps {
  imageUrl: string;
  borderRadius?: string
  height?: string
  title: string;
  subtitle: string;
  subtitleColor: string;
  backgroundColor: string;
  titleColor: string;
  reviewColor: string;
  appDescription: string;
  downloadCount: string;
  overallRating: any
  reviewsCount: any;
  background?: any,
  borderCard?: any
  border?: any, padding?: any
  onClick?: () => void;

}

export default function BannerCardView({
  imageUrl,
  borderRadius,
  background,
  title,
  subtitle,
  subtitleColor,
  backgroundColor,
  titleColor,
  reviewColor,
  appDescription,
  downloadCount,
  overallRating,
  reviewsCount,
  border,
  height,
  padding,
  onClick,
  borderCard

}: BannerCardViewProps) {

  const titleStyle = { color: titleColor };
  const reviewStyle = { color: reviewColor };
  const [maxHeight, setMaxHeight] = useState<number | undefined>(undefined);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (cardRef.current) {
      const maxHeightAmongAllCards = Math.max(
        ...Array.from(document.querySelectorAll('.popular-apps-card')).map(card => card.clientHeight)
      );
      setMaxHeight(maxHeightAmongAllCards);
    }
  }, []);
  return (
    <div className='container'>
      <div
        ref={cardRef}
        className="popular-apps-card flex items-start cursor-pointer group transition-colors"
        onClick={onClick}
        style={{

          borderRadius: borderRadius ?? "15px",
          border: borderCard ?? "1px solid rgb(230, 230, 230)",
          background: background ?? "white",
          padding: padding ?? "20px",
          gap: "18px",
          alignItems: "flex-start",
          flex: "1", // Allow cards to grow equally
          minHeight: "0px", // Ensure content can shrink if needed
          // Set height based on maximum height
        }}
      >
        <div
          className="rounded-sm overflow-hidden shrink-0 relative after:content-[''] absolute inset-0 rounded-sm transition-transform group-hover:scale-[1.025] w-appIcon--sm after:shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]"
          style={{

            background: background ?? '#FFFFFF',
            border: border ?? '1px solid #E2E2E2',
            borderRadius: borderRadius ?? '14px',
            opacity: 1,
            height: '66px'
          }}
        >
          <img
            style={{ maxWidth: '100%', maxHeight: '100%', padding: "10px", }}
            width={66}
            height={66}
            alt=""

            srcSet={imageUrl === '' ? 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png' : imageUrl}
            className="block relative shrink-0 w-appIcon--sm"
            src={imageUrl === '' ? 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png' : imageUrl}
          />
        </div>


        <div className="w-full items-start min-w-0  flex flex-col">
          <div>
            <div className='container' style={{
              fontSize: "18px",
              paddingTop: "9px",
              color: "#131340",


              lineHeight: "1px",
              fontFamily: "sfprobold",
              textTransform: 'capitalize'
            }} >
              {title}
            </div>
          </div>
          {reviewsCount === 0 ? (
            <div>
              <span style={{ display: "inline-flex" }} className="flex items-center">

                <span style={{
                  fontSize: "12px",
                  paddingTop: "6px",
                  opacity: "1",
                  color: "#797979",


                  textTransform: 'capitalize',


                }}>  Free to install</span>

              </span>
            </div>
          ) : (
            <></>
            // <div className="relative flex flex-wrap items-center self-stretch gap-xs text-fg-secondary text-body-sm group-hover:text-fg-highlight-secondary">
            //   <span className="flex items-center">
            //     {typeof overallRating === 'number' && overallRating !== 0 && overallRating !== null ? (
            //       <span style={{
            //         fontSize: "12px",
            //         letterSpacing: "0px",
            //         opacity: "1",
            //         color: "#797979",
            //         textTransform: 'capitalize',

            //       }}>{(overallRating)}</span>
            //     ) : null}
            //     {reviewsCount !== 0 && (
            //       <>
            //         <span>
            //           <img
            //             style={{ marginLeft: "2px" }}
            //             aria-hidden="true"
            //             className="w-[7px]"
            //             src={star}
            //           />
            //         </span>
            //         <span style={{
            //           fontSize: "12px",

            //           opacity: "1",
            //           color: "#797979",
            //           textTransform: 'capitalize',

            //           marginLeft: "4px",
            //         }}>
            //           ({reviewsCount}) Reviews
            //         </span>
            //       </>
            //     )}
            //   </span>
            //   <span style={{
            //     fontSize: "12px",

            //     opacity: "1",
            //     color: "#797979",
            //     textTransform: 'capitalize',
            //     fontWeight: "normal",
            //     marginLeft: "4px",
            //   }}>•</span>
            //   <span style={{
            //     fontSize: "12px",

            //     opacity: "1",
            //     color: "#797979",
            //     textTransform: 'capitalize',
            //     fontWeight: "normal",
            //     marginLeft: "4px",
            //   }} className="overflow-hidden whitespace-nowrap text-ellipsis">Free to install</span>
            // </div>
          )}


          {/* <div style={{

            fontSize: "13px",
            letterSpacing: "0px",
            opacity: "1",
            color: "#131340",
            lineHeight: "1.3"


          }} className="text-body-sm text-fg-tertiary overflow-hidden overflow-ellipsis ">
            {appDescription === null ? "" : appDescription.length > 110 ? `${capitalizeFirstLetter(appDescription).substring(0, 110)}...` : capitalizeFirstLetter(appDescription)}
          </div> */}

          {(
            <div style={{
              fontSize: "14px",
              marginBottom: "10px",

              opacity: "1",
              lineHeight: "1px",
              color: "#131340",
              fontFamily: "sfprobold"
            }} className="cursor-pointer mt-2">
              Know More &rarr;
            </div>
          )}

        </div>

        <div className="border-none border-stroke-secondary"></div>

      </div>
    </div>
  );

  function capitalizeFirstLetter(string) {
    return string.charAt(1).toUpperCase() + string.slice(2);
  }
}
